import { LeadershipEarningsPage } from "@/components/non_registrant/commission-leadership-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/operator/overview_/sales-commission/leadership",
)({
  component: LeadershipEarningsPage,
});
